import { SORT_BY_FACET } from '@/features/shared/constants/global'
import { CategoriesDrawerOption } from '@/features/shop/components/ProductFilter/FilterOptions/CategoriesDrawerOption'
import { FacetOptionsList } from '@/features/shop/components/ProductFilter/FilterOptions/FacetOptionsList'
import { FilterOptions } from '@/features/shop/components/ProductFilter/FilterOptions'
import { FiltersContextProvider } from '@/features/shop/components/ProductFilter/FiltersContext'
import { RetailerFilterOption } from '@/features/shop/components/ProductFilter/FilterOptions/RetailerFilterOption'
import { CategoryTabGroup } from '@/features/shop/components/UngatedCategoryPage/CategoryTabGroup'
import { useMarketingZip } from '@/features/shop/components/UngatedCategoryPage/hooks'
import { type Facet, SearchType } from '@/features/shop/services/Search/types'
import { type UniversalCategory } from '@/features/shop/services/UniversalCategories/types'

type Props = {
  className?: string
  facets: Facet[]
  category: UniversalCategory | undefined
}

export const UngatedFilterOptions = ({ className, facets, category }: Props) => {
  const zip = useMarketingZip()

  return (
    <FiltersContextProvider facets={facets} searchType={SearchType.UNIVERSAL}>
      <FilterOptions className={className}>
        <FacetOptionsList facets={[SORT_BY_FACET]} startIndex={0} />
        {!!category && <CategoriesDrawerOption />}
        <FacetOptionsList
          facets={facets}
          startIndex={category ? 2 : 1}
          renderStoreOption={(index) => (zip ? <RetailerFilterOption index={index} /> : null)}
        />
        {!!category && <CategoryTabGroup category={category} />}
      </FilterOptions>
    </FiltersContextProvider>
  )
}
